<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div>
    <crm-left-side-bar></crm-left-side-bar>
    <v-main class="light-grey">
      <rfi-summary-header v-if="false" />
      <v-container class="mt-1 pa-3 outline" fluid>
        <v-row class="black--text ml-1 mr-1" no-gutters>
          <v-col class="pa-0" cols="12">
            <v-card class="mt-3">
              <v-tabs
                fixed-tabs
                v-model="$store.state.crmData.active_tab"
                background-color="crm-tab"
                active-class="crm-tab-active"
                dark
              >
                <v-tab
                  v-for="item in items"
                  :key="item.tab"
                  he
                  class="crm-tab"
                  @click="
                    $store.state.crmData.tab_history.push($store.state.crmData.active_tab)
                  "
                >
                  {{ item.tab }}
                </v-tab>
              </v-tabs>
              <v-tabs-slider></v-tabs-slider>
              <v-tabs-items v-model="$store.state.crmData.active_tab">
                <v-tab-item v-for="item in items" :key="item.tab" transition="false">
                  <!--                  <v-btn-->
                  <!--                    v-if="$store.state.crmData.tab_history.length > 0"-->
                  <!--                    class="yellow float-right mr-2 mt-2"-->
                  <!--                    @click="tab_back_button"-->
                  <!--                    >Back</v-btn-->
                  <!--                  >-->
                  <v-container fluid>
                    <component :is="item.component_name" />
                  </v-container>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-col>
          <v-col class="pa-0" cols="12">
            <v-card class="mt-3" v-if="$store.state.crmData.active_tab == 0">
              <v-tabs
                fixed-tabs
                v-model="$store.state.crmData.active_process_tab"
                background-color="crm-tab"
                active-class="crm-tab-active-process"
                dark
              >
                <v-tab
                  v-for="item in process_items"
                  :key="item.tab"
                  class="crm-tab"
                  v-model="$store.state.crmData.active_process_tab"
                  @click="
                    $store.state.crmData.process_tab_history.push(
                      $store.state.crmData.active_tab,
                    )
                  "
                >
                  {{ item.tab }}
                </v-tab>
              </v-tabs>
              <v-tabs-slider></v-tabs-slider>
              <v-tabs-items v-model="$store.state.crmData.active_process_tab">
                <v-tab-item
                  v-for="item in process_items"
                  :key="item.tab"
                  transition="false"
                >
                  <!--                  <v-btn-->
                  <!--                    v-if="$store.state.crmData.process_tab_history.length > 0"-->
                  <!--                    class="yellow float-right mr-2 mt-2"-->
                  <!--                    @click="tab_process_back_button"-->
                  <!--                    >Back</v-btn-->
                  <!--                  >-->
                  <v-container fluid>
                    <component :is="item.component_name" />
                  </v-container>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import crmLeftSideBar from '@/components/trade-crm-app/rfi_process/left-side-bar/crm-left-side-bar';
import RfiSummaryHeader from '@/components/trade-crm-app/rfi_process/summary_header/RfiSummaryHeader';
import crmDashboardTab from '@/components/trade-crm-app/rfi_process/tabs/crm-dashboard/crm-dashboard-tab';
import crmManageTagTab from '@/components/trade-crm-app/rfi_process/tabs/manage-tags/crm-manage-tag-tab';
import crmManageCompaniesTab from '@/components/trade-crm-app/rfi_process/tabs/manage-companies/crm-manage-companies-tab';
import crmWorkflowsTab from '@/components/trade-crm-app/rfi_process/tabs/crm-workflows/crm-workflows-tab';
import crmDebugTab from '@/components/trade-crm-app/rfi_process/tabs/crm-debug/crm-debug-tab';

export default {
  name: 'trade-crm-app',
  components: {
    RfiSummaryHeader,
    crmLeftSideBar,
    crmDashboardTab,
    crmManageCompaniesTab,
    crmManageTagTab,
    crmDebugTab,
    crmWorkflowsTab,
  },

  data() {
    return {
      items: [
        {tab: 'Management Area', component_name: 'crmDashboardTab'},
        {tab: '(ADMIN)Company Manager', component_name: 'crmManageCompaniesTab'},
        // {tab: 'RFI info/new', component_name: 'crmWorkflowsTab'},
        // {tab: 'Four', component_name: 'crmWorkflowsTab'},
        // {tab: 'Five', component_name: 'crmWorkflowsTab'},
        // {tab: 'Six', component_name: 'crmWorkflowsTab'},
        // {tab: 'Seven', component_name: 'crmWorkflowsTab'},
        {tab: '(ADMIN) Contact Manager[debug]', component_name: 'crmWorkflowsTab'},
        {
          tab: '(ADMIN)Tag Manager',
          content: 'Tab 9 Content',
          component_name: 'crmManageTagTab',
        },
        {tab: '(ADMIN)DEBUG', content: 'Tab 10 Content', component_name: 'crmDebugTab'},
      ],
      process_items: [
        {tab: 'New RFI', component_name: 'crmWorkflowsTab'},
        {tab: 'Edit RFI', component_name: 'crmWorkflowsTab'},
        {tab: 'Approve RFI', component_name: 'crmWorkflowsTab'},
        {tab: 'Submit RFI ', component_name: 'crmWorkflowsTab'},

        {tab: 'Step a', component_name: 'crmWorkflowsTab'},
        // {tab: 'Four', component_name: 'crmWorkflowsTab'},
        // {tab: 'Five', component_name: 'crmWorkflowsTab'},
        // {tab: 'Six', component_name: 'crmWorkflowsTab'},
        // {tab: 'Seven', component_name: 'crmWorkflowsTab'},
        // {tab: 'Contact Manager[debug]', component_name: 'crmWorkflowsTab'},
        // {tab: 'Tag Manager', content: 'Tab 9 Content', component_name: 'crmManageTagTab'},
        // {tab: 'DEBUG', content: 'Tab 10 Content', component_name: 'crmDebugTab'},
      ],
    };
  },
  methods: {
    tab_back_button() {
      this.$store.state.crmData.active_tab = this.$store.state.crmData.tab_history.pop();
    },
    tab_process_back_button() {
      this.$store.state.crmData.active_tab = this.$store.state.crmData.tab_history.pop();
    },
    debug(v) {
      console.log(v);
    },
  },
};
</script>

<style scoped></style>
